import { sendEtrail, sendPtSurvey } from './services'

const getDefaultState = () => {
  return {}
}

const state = getDefaultState()

// Adds the booking fields every etrail submission carries, wherever it is sent.
const buildEtrailPayload = (rootState, data) => {
  const booking = rootState.booking.booking
  const payload = {
    ...data,
    booking: booking.user_information.bookingNumber,
    branch: booking.booking_information.branch,
    consultant: booking.consultant_information.name,
    contactbranch: booking.booking_information.contact_branch,
    deptdate:
      booking.itinerary_transformed &&
      booking.itinerary_transformed.items &&
      booking.itinerary_transformed.items.length
        ? booking.itinerary_transformed.items[0].title_date
        : '',
    copy: false,
    crsbkg: '',
    sdesks: booking.booking_information.SDK,
    tsd: ' ',
  }
  // Check if we have a passenger record and if postcode field is empty
  // If it is update to 'please advise' as this is what the SF field will be populated with
  if (payload && payload.passenger && !payload.passenger.postcode) {
    payload.passenger.postcode = 'please advise'
  }
  return payload
}

const actions = {
  async sendEtrailAction({ commit, rootState }, data) {
    const res = await sendEtrail(buildEtrailPayload(rootState, data))
    if (res) {
      return res
    }
  },
  // Post-travel surveys stay on apiserver (see sendPtSurvey in services.js).
  async sendPtSurveyAction({ commit, rootState }, data) {
    return sendPtSurvey(buildEtrailPayload(rootState, data))
  },
  resetStateAction({ commit }) {
    commit('resetState')
  },
}

const mutations = {
  resetState(state) {
    Object.assign(state, getDefaultState())
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
}
